import React from 'react'
import { withRouter } from 'react-router-dom';
import {Box,Card,CardHeader, CardBody,Button,Heading, Text,CardFooter} from 'grommet';
import {  Alert,Update } from 'grommet-icons';
import {NavigationSnackBar} from '../../components/utils/shared/shared'

function ShipmentFail(props) {
  const shipment = (props.location.state.shipment.response.hasOwnProperty("SuggestedCourier") ? props.location.state.shipment.response.SuggestedCourier : props.location.state.shipment.response)
  const origin = props.location.state.shipment.shipment.origin
  const destination = props.location.state.shipment.shipment.destination
  const details = props.location.state.shipment.shipment.pieces
  if (props.error){
    return (
        <Box>
          <NavigationSnackBar title={'Shipment Unsuccuessful'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Shipment', link: '/shipments/new'}]}  />
          <Box direction='column' justify="center" margin='small'>
              <Card pad="medium" gap="small" justify='start' align='start'>
                  <CardHeader>
                  <Alert color='status-critical'/>
                      <Heading level={4} size="small">Shipment Request Unsuccessful</Heading>
                  </CardHeader>
                  <CardBody justify='start' direction='column'>
                      <Text size='small'>Please check the shipment details and ensure all addresses are correct.</Text>
                      <Text size='small'>If the problem persists, please contact support on  <a href="mailto:labship@samplelogistics.com?subject=LabShip Shipment Error">labship@samplelogistics.com</a>.</Text>
                  </CardBody>
                  <CardFooter>
                  <Button margin="small" icon={<Update color='status-ok'/>} label={"Try Again"} type='button' onClick={() =>props.history.push({pathname: '/shipment/new', origin: origin, destination: destination, details:details, reship:true})}/>
                  </CardFooter>
              </Card>
          </Box>
      </Box>
    )
  } else {
    return (
        <Box>
          <NavigationSnackBar title={'Shipment Unsuccuessful'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Shipment', link: '/shipments/new'}]}  />
          <Box direction='row' justify="center" margin='small'>
              <Card margin={'small'} pad="medium" gap="small" justify='start' align='center' elevation='large' color='background-front'>
                  <CardHeader>
                  <Alert color='status-critical'/>
                      <Heading level={4} size="small">Shipment Request Unsuccessful</Heading>
                  </CardHeader>
                  <CardBody justify='start' direction='column' margin={{top:'small'}}>
                      <Text>Error Code: {shipment.Status.Code}</Text>
                      <Text>Error Message: {shipment.Status.Message}. {shipment.Status.Detail}</Text>
                      {(shipment.Status.hasOwnProperty("AdditionalDetail") && (
                        shipment.Status.AdditionalDetail.map(detail => {
                           return <Box margin={{top:'small'}} border='top' direction='row'><Alert style={{marginTop:10, marginRight:10}} color='status-critical'/><Text weight='bold' margin={{top:'small', left:'small'}} size='small'>{detail}</Text></Box>
                        })
                      ))}
                  </CardBody>
                  <CardFooter margin={{top:'medium'}}>
                      <Button margin="small" icon={<Update color='status-ok'/>} label={"Try Again"} type='button' onClick={() =>props.history.push({pathname: '/shipment/new', origin: origin, destination: destination, details:details, reship:true})}/>
                  </CardFooter>
              </Card>
          </Box>
      </Box>
    )
  }

}

export default withRouter(ShipmentFail)
